<template>
  <div>
    <list-table
      :url="url"
      title="لیست مشتریان"
      :fields="fields"
      :params="params"
      :excelroute="'asdasd'"
    ></list-table>
  </div>
</template>
  <script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import moment from "jalali-moment";

export default {
  name: "Customers",
  data() {
    return {
      url: "accounters-report/get-customers",
      val1: null,
      val2: null,
      params: [
        // {
        //   label: "تاریخ",
        //   field: "date",
        //   type: "date-picker"
        // },
      ],
      fields: [
        {
          key: "id",
          label: "کد مشتری",
        },
        {
          key: "name",
          label: "نام مشتری",
        },
        {
          key: "mobile",
          label: "تلفن همراه",
        },
        {
          key: "national_card_number",
          label: "کد ملی/ کد اقتصادری",
        },
        {
          key: "address",
          label: "آدرس",
          formatter(value, key, item) {
            return (
              item.user_province.title +
              " - " +
              item.user_city.title +
              " - " +
              value
            );
          },
        },
      ],
      // detailUrl:"SharingDetails",
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {
    loadedComparative() {
      return this.$store.getters.loadedComparative;
    },
    loadedMoein() {
      return this.$store.getters.loadedMoein;
    },
  },
  methods: {},
  created() {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست مشتریان" }]);
  },
};
</script>